import { Link } from "react-router-dom";
import { Phone, Mail, ShieldCheck } from "lucide-react";
import { LOGO_URL, PHONE, PHONE_HREF, EMAIL, LICENSE } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-[#060608] border-t border-[rgba(212,175,55,0.2)]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img src={LOGO_URL} alt="McMullen Construction Co. logo" className="h-16 w-auto rounded-sm gold-frame" />
            <p className="mt-6 font-display text-2xl text-[#F4F2EE]">McMullen Construction Co.</p>
            <p className="mt-1 font-mono-accent text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">Remodel &amp; New Construction</p>
          </div>

          <nav aria-label="Footer" className="md:justify-self-center">
            <p className="eyebrow mb-5">Explore</p>
            <ul className="space-y-3 text-sm">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Services", "/services"],
                ["Gallery", "/gallery"],
                ["Contact", "/contact"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-link-${label.toLowerCase()}`} className="text-[#A1A1AA] hover:text-[#F3E081] transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:justify-self-end">
            <p className="eyebrow mb-5">Get In Touch</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={PHONE_HREF} data-testid="footer-phone-link" className="flex items-center gap-3 text-[#F4F2EE] hover:text-[#F3E081] transition-colors">
                  <Phone className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" /> {PHONE}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-3 text-[#A1A1AA] hover:text-[#F3E081] transition-colors break-all">
                  <Mail className="h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" /> {EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#A1A1AA]">
                <ShieldCheck className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" />
                <span data-testid="footer-license-text">Licensed Florida General Contractor - {LICENSE}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline-gold mt-14 pt-7 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#71717A]">
          <p data-testid="footer-copyright">© 2026 McMullen Construction Co. All rights reserved. {LICENSE}</p>
          <p data-testid="footer-design-credit">
            Website Designed By{" "}
            <a
              href="https://bp.agency"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-brand-partners-link"
              className="font-bold text-[#D4AF37] hover:text-[#F3E081] transition-colors"
            >
              Brand Partners
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
